<template>
  <div class="w-select">
    <label
      for="select"
      class="select-label"
      :style="{
        color: tonal.white.white,
        backgroundColor: tonal.gray[700],
      }"
      @click.stop="togglePopup"
    >
      <div class="text">
        <span
          v-if="!selectedValue"
          class="placeholder"
          :style="{
            color: tonal.white.white,
          }"
        >
          {{ placeholder }}
        </span>
        <span
          v-else
          class="selected"
          :style="{
            color: tonal.white.white,
          }"
        >
          {{ selectedTitle }}
        </span>
      </div>

      <div class="append-icon">
        <arrow-icon :width="12" :height="12" :color="tonal.white.white" />
      </div>
    </label>

    <w-popup
      :is-open="isOpen"
      :toggle-popup="togglePopup"
      :options="options"
      :selected="{
        title: selectedTitle,
        value: selectedValue,
      }"
      @close="togglePopup"
      @select="onSelect"
    />
  </div>
</template>

<script>
  import WPopup from '@/components/ui/popup'
  import { ArrowIcon } from '@/components/Icons'
  import { tonal } from '@/constants/tonal'

  export default {
    components: {
      ArrowIcon,
      WPopup,
    },
    props: {
      type: {
        default: 'default',
        validator: (value) =>
          ['default', 'primary', 'secondary', 'warning', 'danger'].includes(
            value,
          ),
      },

      placeholder: {
        type: String,
        default: '선택하세요',
      },

      options: {
        type: Array,
        default: () => [],
      },
    },

    data() {
      return {
        isOpen: false,
        selectedTitle: '',
        selectedValue: '',
        tonal,
      }
    },

    watch: {
      options: {
        deep: true,

        handler(newOptions) {
          this.options.value = [...newOptions]
        },
      },
      $route: {
        handler(newRoute, oldRoute) {
          this.isOpen = false

          if (newRoute.query.subCode === oldRoute.query.subCode) return

          if (newRoute.query.subCode !== this.selectedValue) {
            this.selectedValue = newRoute.query.subCode
            this.selectedTitle = this.options.find(
              (option) => option.value === newRoute.query.subCode,
            )?.title
          }
        },
      },
    },
    methods: {
      togglePopup() {
        this.isOpen = !this.isOpen

        if (this.isOpen) {
          this.toggleBodyOverflow(true)
        } else {
          this.toggleBodyOverflow(false)
        }
      },

      toggleBodyOverflow(hidden) {
        if (hidden) {
          document.body.style.overflow = 'hidden'
        } else {
          document.body.style.overflow = ''
        }
      },

      onSelect({ option, index }) {
        this.selectedTitle = option.title
        this.selectedValue = option.value

        // api 요청하기
        this.$emit('selected', { option, index })
      },
    },
  }
</script>

<style lang="scss" scoped>
  .w-select {
    position: relative;
    display: flex;
    flex: 1 1 auto;
    min-width: 100px;

    .select-label {
      font-size: 14px;
      line-height: 20px;
      padding: 0;
      display: flex;
      align-items: center;
      gap: 2px;
      cursor: pointer;
      padding: 8px 12px;
      border-radius: 8px;
      max-width: 100%;
    }

    .text {
      margin-right: 2px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      flex: 1;
    }

    .append-icon {
      display: flex;
      justify-content: center;
      align-items: center;
      transition: transform 0.15s ease-in-out;
    }
  }

  .dim {
    position: fixed;
    overflow: hidden;
    z-index: 1;

    .options {
      cursor: pointer;
      overflow-y: scroll;
    }
  }
</style>
